import React, { useEffect, useState, useContext } from 'react';

import { DeepCopy } from '../../tables/shared/TableEventHelpers';
import { HandlePatchDeal } from '../requests/DealRequests';

import WonModal from '../WonModal';
import LostModal from '../LostModal';

import { DataContext } from '../../../stores/crm-deal-store';
import { DataContext as CrmDataContext } from '../../../stores/crm-store';

export const ResolveDealButtons = ({ activeDeal, updateStore }) => {
    const crmDealStore = useContext(DataContext);
    const crmStore = useContext(CrmDataContext);

    const [className, setClassName] = useState(activeDeal.dealStatus !== null ? 'd-none' : 'd-flex');

    async function handleDealWon(item) {
        delete item.project;
        item.dealStatus = true;

        var response = await HandlePatchDeal(activeDeal, item);
        checkSuccess(response, crmDealStore, crmStore);
        if (response.success) {
            updateStore(response.deal);
        }

        return response;
    }

    async function handleDealLost(item) {
        delete item.lostReason;
        item.dealStatus = false;

        var response = await HandlePatchDeal(activeDeal, item);
        checkSuccess(response, crmDealStore, crmStore);
        if (response.success) {
            updateStore(response.deal);
        }

        return response;
    }

    useEffect(() => {
        setClassName(activeDeal.dealStatus !== null ? 'd-none' : 'd-flex');
    }, [activeDeal]);

    return (
        <div className={`flex-row my-auto ${className}`} style={{ height: 45 }}>
            <WonModal
                handleUpdate={handleDealWon}
                label='Won'
                description={`Markera "${activeDeal.name}" som vunnen`}
                initialValues={DeepCopy(activeDeal)}
            />
            <LostModal
                handleUpdate={handleDealLost}
                label='Lost'
                description={`Markera "${activeDeal.name}" som förlorad`}
                initialValues={DeepCopy(activeDeal)}
            />
        </div>
    );
};

export const ReOpenDealButton = ({ activeDeal, updateStore }) => {
    const crmDealStore = useContext(DataContext);
    const crmStore = useContext(CrmDataContext);

    async function reOpenDeal() {
        var copy = DeepCopy(activeDeal);
        copy.lostReasonId = null;
        copy.lostReason = null;
        copy.dealStatus = null;
        var response = await HandlePatchDeal(activeDeal, copy);
        checkSuccess(response, crmDealStore, crmStore);
        if (response.success) {
            updateStore(response.deal);
        }
    }

    if (activeDeal.dealStatus !== null) {
        return (
            <>
                <div className='m-1' style={{ width: 60, height: 30 }}>
                    <span
                        align='center'
                        className={
                            'badge badge-pill w-100 h-100 ' +
                            (activeDeal.dealStatus ? 'badge-success' : '') +
                            (!activeDeal.dealStatus ? 'badge-danger' : '')
                        }>
                        <div className='w-100 h-100 d-flex justify-content-center align-items-center'>
                            {activeDeal.dealStatus ? 'Won' : null}
                            {!activeDeal.dealStatus ? 'Lost' : null}
                        </div>
                    </span>
                </div>
                <button
                    type='button'
                    className={`btn btn-primary mr-1 crm-modal-btn justify-content-center align-content-center`}
                    onClick={() => reOpenDeal()}>
                    <div>Reopen Deal</div>
                </button>
            </>
        );
    } else {
        return null;
    }
};

const checkSuccess = (response, crmDealStore, crmStore) => {
    if (response.success) {
        crmDealStore.dispatch({
            type: 'UPDATE_ACTIVE_DEAL',
            payload: response.deal,
        });
        crmStore.dispatch({ type: 'SHOW_SAVED_TOAST' });
    } else {
        crmStore.dispatch({ type: 'SHOW_ERROR_TOAST' });
    }
};
